import { sortAlphabetically } from "../components/admin/helper/formatters";
import { IBigscreenSettings, ICustomMetrics } from "../constants/interfaces";

export function computeCustomFields(bigscreenSettings: IBigscreenSettings[]): ICustomMetrics[] {
    const brandsWithCustomMetrics = bigscreenSettings.filter(settings => settings.features.indexOf("custommetrics") !== -1);
    const allCustomMetrics = brandsWithCustomMetrics.flatMap(brand => brand.customMetrics || []);
    const customFields = Object.values(
        allCustomMetrics.reduce<Record<string, ICustomMetrics>>((acc, metric) => {
            acc[metric.id] = metric;
            return acc;
        }, {})
    );

    return sortAlphabetically(customFields, 'label');
}

export default computeCustomFields;
